import { FC, useEffect, useState } from 'react';
import { Skeleton, Text } from '@mantine/core';
import { useNavigate, useParams } from 'react-router-dom';
import { CreateContractConfigDTO, ProcedureReportProps } from '../../../../Types/LogT';
import { fetchContractTemplate } from '../../../../Service/restapi/contractService';
import LinkText from '../../../../Atoms/LinkText';

const CreateContractReport: FC<ProcedureReportProps> = ({ report, config }) => {
  const { templateId } = config as CreateContractConfigDTO;
  const { entityId, executionStatus } = report ?? {};
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState<any>();
  const contractCreated = executionStatus === 'COMPLETED';

  const onClick = () => {
    if (eventId && contractCreated) {
      navigate(`/events/${eventId}/contracts/${entityId}`);
    }
  };

  useEffect(() => {
    if (templateId) {
      setLoading(true);
      fetchContractTemplate(templateId)
        .then((resJSON) => {
          if (resJSON) {
            setTemplate(resJSON);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [templateId]);

  return (
    <Text>
      <Text
        span
        weight="bolder"
        onClick={onClick}
        variant={contractCreated ? 'link' : 'text'}
        sx={(theme) => ({
          cursor: contractCreated ? 'pointer' : 'default',
          color: contractCreated
            ? theme.colorScheme === 'dark'
              ? theme.colors.blue[1]
              : theme.colors.blue[4]
            : 'inherit',
        })}
      >
        Vertrag
      </Text>{' '}
      wurde aus Vorlage{' '}
      {loading || !template ? (
        <Skeleton mb={-3} height={16} width={100} sx={{ display: 'inline-block' }} />
      ) : (
        <LinkText span weight="bolder" onClick={() => navigate(`/settings/template/contract/${template.name}`)}>
          {template.name}
        </LinkText>
      )}{' '}
      erstellen.
    </Text>
  );
};

export default CreateContractReport;
